import { jsxs as C, jsx as i } from "react/jsx-runtime";
import { getMainIconProps as d } from "./index.es2444.js";
function a(t) {
  const { outline: e, fill: n, size: l, innerElementFill: p } = d(t);
  return /* @__PURE__ */ C(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("g", { clipPath: "url(#clip0_260_3591)", children: [
          /* @__PURE__ */ i(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M13.5 4.875C12.947 4.875 12.5 4.427 12.5 3.875C12.5 3.323 12.947 2.875 13.5 2.875C14.053 2.875 14.5 3.323 14.5 3.875C14.5 4.427 14.053 4.875 13.5 4.875ZM4.5 4.875C3.947 4.875 3.5 4.427 3.5 3.875C3.5 3.323 3.947 2.875 4.5 2.875C5.053 2.875 5.5 3.323 5.5 3.875C5.5 4.427 5.053 4.875 4.5 4.875ZM17 1.375H1C0.447 1.375 0 1.823 0 2.375V6.125H18V2.375C18 1.823 17.553 1.375 17 1.375Z",
              fill: n
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              shapeRendering: "optimizeQuality",
              d: "M7.5 4C7.29289 4 7.125 4.16789 7.125 4.375C7.125 4.58211 7.29289 4.75 7.5 4.75H10.5C10.7071 4.75 10.875 4.58211 10.875 4.375C10.875 4.16789 10.7071 4 10.5 4H7.5Z",
              fill: e
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              shapeRendering: "optimizeQuality",
              d: "M3.4668 9.4585C3.25969 9.4585 3.0918 9.62639 3.0918 9.8335C3.0918 10.0406 3.25969 10.2085 3.4668 10.2085H5.4668C5.6739 10.2085 5.8418 10.0406 5.8418 9.8335C5.8418 9.62639 5.6739 9.4585 5.4668 9.4585H3.4668Z",
              fill: e
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              shapeRendering: "optimizeQuality",
              d: "M8.0293 9.4585C7.82219 9.4585 7.6543 9.62639 7.6543 9.8335C7.6543 10.0406 7.82219 10.2085 8.0293 10.2085H10.0293C10.2364 10.2085 10.4043 10.0406 10.4043 9.8335C10.4043 9.62639 10.2364 9.4585 10.0293 9.4585H8.0293Z",
              fill: e
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              shapeRendering: "optimizeQuality",
              d: "M12.2168 9.8335C12.2168 9.62639 12.3847 9.4585 12.5918 9.4585H14.5918C14.7989 9.4585 14.9668 9.62639 14.9668 9.8335C14.9668 10.0406 14.7989 10.2085 14.5918 10.2085H12.5918C12.3847 10.2085 12.2168 10.0406 12.2168 9.8335Z",
              fill: e
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              shapeRendering: "optimizeQuality",
              d: "M3.4668 13.7603C3.25969 13.7603 3.0918 13.9282 3.0918 14.1353C3.0918 14.3424 3.25969 14.5103 3.4668 14.5103H5.4668C5.6739 14.5103 5.8418 14.3424 5.8418 14.1353C5.8418 13.9282 5.6739 13.7603 5.4668 13.7603H3.4668Z",
              fill: e
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              shapeRendering: "optimizeQuality",
              d: "M7.6543 14.1353C7.6543 13.9282 7.82219 13.7603 8.0293 13.7603H10.0293C10.2364 13.7603 10.4043 13.9282 10.4043 14.1353C10.4043 14.3424 10.2364 14.5103 10.0293 14.5103H8.0293C7.82219 14.5103 7.6543 14.3424 7.6543 14.1353Z",
              fill: e
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              shapeRendering: "optimizeQuality",
              d: "M12.5918 13.7603C12.3847 13.7603 12.2168 13.9282 12.2168 14.1353C12.2168 14.3424 12.3847 14.5103 12.5918 14.5103H14.5918C14.7989 14.5103 14.9668 14.3424 14.9668 14.1353C14.9668 13.9282 14.7989 13.7603 14.5918 13.7603H12.5918Z",
              fill: e
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M4.875 0.375C4.875 0.167893 4.70711 0 4.5 0C4.29289 0 4.125 0.167893 4.125 0.375V1H1C0.447715 1 0 1.44772 0 2V17C0 17.5523 0.447716 18 1 18H17C17.5523 18 18 17.5523 18 17V2C18 1.44772 17.5523 1 17 1H13.875V0.375C13.875 0.167893 13.7071 0 13.5 0C13.2929 0 13.125 0.167893 13.125 0.375V1H4.875V0.375ZM1 1.75H4.125V3.875C4.125 4.08211 4.29289 4.25 4.5 4.25C4.70711 4.25 4.875 4.08211 4.875 3.875V1.75H13.125V3.875C13.125 4.08211 13.2929 4.25 13.5 4.25C13.7071 4.25 13.875 4.08211 13.875 3.875V1.75H17C17.1381 1.75 17.25 1.86193 17.25 2V5.75H0.75V2C0.75 1.86193 0.861929 1.75 1 1.75ZM17.25 6.5V17C17.25 17.1381 17.1381 17.25 17 17.25H1C0.861929 17.25 0.75 17.1381 0.75 17V6.5H17.25Z",
              fill: e
            }
          )
        ] }),
        /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("clipPath", { id: "clip0_260_3591", children: /* @__PURE__ */ i(
          "rect",
          {
            shapeRendering: "optimizeQuality",
            width: "18",
            height: "18",
            fill: p
          }
        ) }) })
      ]
    }
  );
}
a.__tags = [];
export {
  a as CalendarIcon
};
//# sourceMappingURL=index.es257.js.map
